<div *ngIf="!isInvestidor" class="col-lg-11 col-sm-12 col-md-12 box-form p-5 mt-3">
  <div class="row">
    <span data-testid="botao-voltar" class="back-button" (click)="voltarInicio()">
      <i class="fas fa-angle-left"></i> voltar
    </span>
  </div>
  <div class="d-flex justify-content-center">
    <div class="col-sm-12 d-flex justify-content-center  col-md-4 ">
      <!-- Type form 3 to investidores -->
      <div data-testid="botao-investidor" class="card custom-btn-hover p-2" (click)="setType(1)">
        <fieldset class="d-flex h-100 align-items-center justify-content-center">
          <legend class="my-3 text-center">Investidor</legend>
          <img src="../../../../assets/icons/pessoa-fisica.svg  " alt="">
        </fieldset>
      </div>
    </div>
<!--    <div class="col-sm-12 d-flex justify-content-center  col-md-4 ">-->
<!--      <div data-testid="botao-corretoras-dtvm" class="card custom-btn-hover p-2" (click)="setType(2)">-->
<!--        <fieldset class="d-flex h-100 align-items-center justify-content-center">-->
<!--          <legend class="my-3 text-center">Corretoras / Adm. Fundos / DTVM'S</legend>-->
<!--          <img src="../../../../assets/icons/pj.svg" alt="">-->
<!--        </fieldset>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</div>
<div *ngIf="isInvestidor" class="col-lg-10 col-sm-12 col-md-12 box-form p-5 d-flex flex-column justify-content-center mt-3">
  <div class="row">
    <span data-testid="botao-voltar" class="back-button" (click)="backStep()">
      <i class="fas fa-angle-left"></i> voltar
    </span>
  </div>
  <div class="row mt-5 justify-content-center">
    <div class="col-sm-12 d-flex justify-content-center  col-md-4 ">
      <div data-testid="botao-investidor-pf" class="card custom-btn-hover p-2" (click)="setForm(1)">
        <fieldset class="d-flex justify-content-center">
          <legend class="text-center my-4">Investidor Pessoa Física</legend>
          <img src="../../../../assets/icons/CPF-PF.svg" alt="">
        </fieldset>
      </div>
    </div>
    <div class="col-sm-12 d-flex justify-content-center col-md-4 ">
      <div data-testid="botao-investidor-pj" class="card custom-btn-hover p-2" (click)="setForm(2)">
        <fieldset class="d-flex justify-content-center">
          <legend class="text-center my-4">Investidor Pessoa Jurídica</legend>
          <img src="../../../../assets/icons/PJ-CNPJ.svg" alt="">
        </fieldset>
      </div>
    </div>
    <!-- <div class="col-sm-12 d-flex justify-content-center  col-md-4 ">
      <div data-testid="botao-fundo-investimento" class="card custom-btn-hover p-2" (click)="setForm(3)">
       <fieldset class="d-flex justify-content-center">
         <legend class="text-center my-4">Fundo de Investimento</legend>
         <img width="230px" src="../../../../assets/icons/Fundo investimento.svg" alt="">
       </fieldset>
     </div>
   </div> -->
  </div>
</div>
